/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule shallowEqual
 * @typechecks
 *
 */

'use strict';

let hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
export function shallowEqual(objA, objB) {
    return equal(objA, objB);
}

export default shallowEqual;

export function equal(objA, objB, equal = null) {
    if (objA === objB) {
        return true;
    }

    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
        return false;
    }

    let keysA = Object.keys(objA);
    let keysB = Object.keys(objB);

    if (keysA.length !== keysB.length) {
        return false;
    }

    // Test for A's keys different from B.
    let bHasOwnProperty = hasOwnProperty.bind(objB);
    for (let i = 0; i < keysA.length; i++) {
        const key = keysA[ i ];
        const oA = objA[ key ];
        const oB = objB[ key ];
        if (!bHasOwnProperty(key) || (equal ? !equal(oA, oB, key) : oB !== oA)) {
            return false;
        }
    }

    return true;
}

export function equalArray(o1, o2, equal = null) {
    if  (equal){
        return o1 && o2 && o1.length === o2.length && o1.findIndex((p1, idx) => !equal(p1, o2[ idx ])) < 0;
    }
    return o1 && o2 && o1.length === o2.length && o1.findIndex((p1, idx) => p1 !== o2[ idx ]) < 0;
}

/**
 * Checks if every prop in b is also existing in a and if it the same value.
 *
 * Examples:
 * a={} b={foo: 'bar'} => shallowContains(a, b) => false
 * a={foo: 'bar'} b={foo: 'bar'} => shallowContains(a, b) => true
 * a={foo: 'bar'} b={foo: 'rab'} => shallowContains(a, b) => false
 */
export function shallowContains(a, b) {
    return Object.keys(b).findIndex(k => a[ k ] !== b[ k ]) < 0
}


// WEBPACK FOOTER //
// ./js/utils/shallowEqual.js